export enum ProcessStepStatus {
  COMPLETED = <any>'completed',
  NOT_COMPLETED = <any>'not-completed',
  CURRENT = <any>'current-step',
  WAITING = <any>'waiting'
}
